import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { DwellingContract } from './../../model/dwelling-contract';
import { ContractService } from './../base/contract';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { Observable } from 'rxjs';
import { DwellingInspection } from '../../../dwelling-inspection/model/dwelling-inspection';
import { Contract } from '../../model/contract';

@Injectable()
export class DwellingContractService extends ContractService<DwellingContract> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, DwellingContract, progressBar, 'dwelling-contract');
  }

  protected createModel(data: any): DwellingContract {
    const model = super.createModel(data);
    if (data.dwellingInspections instanceof Array) {
      model.dwellingInspections = data.dwellingInspections.map(item => new DwellingInspection(item));
    }

    return model;
  }

  getNameplate(companyId: string, tenantOneName: string, tenantTwoName: string | null): Observable<string> {
    const params = new HttpParams()
      .set('id', companyId)
      .set('tenantOneName', tenantOneName)
      .set('tenantTwoName', tenantTwoName || 'null');

    return this.client.get(`${this.endpoint}/getNameplate`, { params, responseType: 'text' });
  }

  retrieveUpdatedLeaseAgreementDwelling(contract: Contract): Observable<any> {
    return this.client.patch(`${this.endpoint}/get-updated-dwelling`, contract);
  }
}
